export const comphelpers = {generateFormattedDates};
function generateFormattedDates(numberOfMonths){
    const currentDate = new Date();
    
    const formattedDates = Array.from({ length: numberOfMonths }, (_, index) => {
        const date = new Date(currentDate);
        date.setMonth(currentDate.getMonth() - index);
        // console.log(date); 

        const year = date.getFullYear();
        const month = date.toLocaleString('default', { month: 'short' });

        // Handle edge case for May 31st:
        
        return `${year}-${month}`;
    });
    
 
    let emparr = [];
    formattedDates.forEach((value,index)=>{
       emparr.push((<option value={value}>{value}</option>)); 
    }); 
    
    return emparr;
    };



 